// Standalone config module (same rule as config.ts) — MUST NOT import from
// other shared modules that depend on this one (map.ts, monsters.ts, world.ts).
// Zone id doubles as the Colyseus room name — one Room per zone.
export type ZoneId = "zone_gangnam" | "zone_hongdae";

export interface ZoneDef {
  id: ZoneId;
  name: string;
}

export const ZONES: Record<ZoneId, ZoneDef> = {
  zone_gangnam: { id: "zone_gangnam", name: "강남 / 역삼" },
  zone_hongdae: { id: "zone_hongdae", name: "홍대 / 마포" },
};

export const ZONE_IDS: ZoneId[] = ["zone_gangnam", "zone_hongdae"];

export const DEFAULT_ZONE: ZoneId = "zone_gangnam";

export function isZoneId(value: unknown): value is ZoneId {
  return typeof value === "string" && (ZONE_IDS as string[]).includes(value);
}
